import * as React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import TriggerModal from "./TriggerModal";
import useApi from "@/hooks/useApi";
import useToastAlert from "@/hooks/useToastAlert";
import { Severity } from "@velaro/velaro-component-lib";

export default function NewWorkflowButton() {
  const navigate = useNavigate();
  const api = useApi();
  const { displayToast } = useToastAlert();
  const [showTriggerModal, setShowTriggerModal] = useState(false);
  const [creating, setCreating] = useState(false);

  async function selectTrigger(triggerId: string) {
    setShowTriggerModal(false);
    setCreating(true);
    try {
      const response = await api.messaging.post("Workflows", {
        trigger: triggerId
      });
      if (!response.ok) {
        displayToast(Severity.Error, "Failed to create workflow");
        return;
      }
      const workflowId = await response.json();
      navigate(`/workflows/${workflowId}`);
    } catch (e) {
      console.error("[NewWorkflowButton] failed to create workflow —", e);
      displayToast(Severity.Error, "Failed to create workflow — please try again");
    } finally {
      setCreating(false);
    }
  }

  return (
    <>
      <button
        type="button"
        onClick={() => selectTrigger("conversation_opened")}
        disabled={creating}
        className="flex items-center gap-1.5 px-3 py-1.5 bg-primary hover:bg-primary-active text-white text-sm font-medium rounded-lg transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
      >
        <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <line x1="12" y1="5" x2="12" y2="19" />
          <line x1="5" y1="12" x2="19" y2="12" />
        </svg>
        {creating ? "Creating..." : "Create Workflow"}
      </button>
      {showTriggerModal && (
        <TriggerModal
          onSelect={selectTrigger}
          onClose={() => setShowTriggerModal(false)}
        />
      )}
    </>
  );
}
